import React from "react"
import RaisedButton from "material-ui/RaisedButton"
import PropTypes from "prop-types"

import TextField from "material-ui/TextField"
import FlatButton from "material-ui/FlatButton"
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton"
import StateSelectField from "../../../../components/misc/StateSelectField"
import IdentityDocSelectField from "./IdentityDocSelectField"
import AuthorizeToWork from "./AuthorizeToWork"
import UploadDocImage from "./UploadDocImage"
import GovernmentDocInfo from "./GovernmentDocInfo"

const i9Actions = require("../../../../actions/I9Actions")
const userActions = require("../../../../actions/UserActions")
const propTypes = {
    i9: PropTypes.object
}

export default class PreparerInfo extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            quickSelection: -1,
            i9: props.i9
        }
        this.onChange = this.onChange.bind(this)
        this.onIdentityDocInfoChange = this.onIdentityDocInfoChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.i9) {
            this.setState({
                i9: nextProps.i9
            })
        }
    }

    getState() {}

    onStateChange() {}

    onChange(event, value) {
        this.setState({
            quickSelection: value
        })
    }

    onIdentityDocInfoChange(governmentDoc) {
        const _this = this
        i9Actions.addGovernmentDoc(this.state.i9.Id, governmentDoc).then(function(result) {
            userActions.loadUserDetails(_this.state.i9.UserId)
        })
    }

    render() {
        return (
            <div className="identity-info IdentityInfo">
                <p>
                    <b>Employee Identity Document</b>
                </p>
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td style={{ verticalAlign: "top" }}>
                                    <p>Choose an employee supplied document that establishes the employee identity:</p>
                                    <RadioButtonGroup name="quickSelectIdentity" onChange={this.onChange} valueSelected={this.state.quickSelection}>
                                        <RadioButton value={0} label="Passport (US or Foreign)" />
                                        <RadioButton value={1} label="Driver's License" />
                                        <RadioButton value={2} label="Other" />
                                    </RadioButtonGroup>
                                    {this.state.quickSelection === 2 && (
                                        <div>
                                            <IdentityDocSelectField />
                                        </div>
                                    )}
                                </td>
                                <td style={{ verticalAlign: "top" }}>
                                    {this.state.quickSelection > -1 && (
                                        <div>
                                            <GovernmentDocInfo handleChange={this.onIdentityDocInfoChange} />
                                        </div>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {this.state.quickSelection > 0 && (
                        <div>
                            <AuthorizeToWork />
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

PreparerInfo.propTypes = propTypes
